import React, { useState, useEffect } from "react";
import SampleDashboardLayout from "./SampleDashboardLayout";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAvaiedServicesAPI,
  getAvaiedServicesDetailAPI,
  sendFeedbackAPI,
} from "../../../redux/slices/availedServiceSlice";
import { base, errorHandler, formatTime, formatTimeToAMPM } from "../../../constants/base";
import { toast } from "react-toastify";
import EmptyState from "../../../components/EmptyState/EmptyState";

const SampleRating = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.AuthSlice.user);
  const serviceDetail = useSelector(
    (state) => state?.availedServiceSlice?.requestDetail
  );
  const feedBackLoading = useSelector(
    (state) => state?.availedServiceSlice?.feedBackLoading
  );
  const detailLoading = useSelector(
    (state) => state?.availedServiceSlice?.detailLoading
  );
  const availedServices = useSelector(
    (state) => state?.availedServiceSlice?.availedServices
  );
  const loading = useSelector((state) => state?.availedServiceSlice?.loading);
  const pagination = useSelector(
    (state) => state?.availedServiceSlice?.pagination
  );
  const [currentPage, setCurrentPage] = useState(pagination.current_page);
  const ratingStars = serviceDetail?.feedback?.stars || 0;

  // GET AVAILED SERVCIES
  const aviledServiceData = {
    id: user?.id,
    page: currentPage,
  };

  const fetchAvailedServices = async () => {
    const res = await dispatch(getAvaiedServicesAPI(aviledServiceData));
  };

  useEffect(() => {
    fetchAvailedServices();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  // GET AVAILED SERVCIES

  const [showFields, setShowFields] = useState("");

  const toggleDataReq = (index) => {
    setShowFields((prev) => (prev === index ? "" : index));
  };

  // STARS RATING
  const [rating, setRating] = useState(0);

  // Function to handle star click
  const handleRating = (index) => {
    setRating(index + 1);
  };

  // GET SERVICES DETAIL HERE
  const handleDetailRequest = async (id) => {
    const res = await dispatch(getAvaiedServicesDetailAPI(id));
    setShowFields("");
  };
  // GET SERVICES DETAIL HERE

  // GIVE FEEDBACK HERE
  const [ratingTextBox, setRatingTextBox] = useState();

  const handleRatingForm = async (e) => {
    e.preventDefault();
    const feedBackData = {
      user_id:
        serviceDetail?.user?.role?.name === "professional"
          ? serviceDetail?.user_id
          : serviceDetail?.employee_id,
      customer_id: serviceDetail?.customer_id,
      service_id: serviceDetail?.service_id,
      request_id: serviceDetail?.id,
      stars: rating,
      message: ratingTextBox,
    };

    const res = await dispatch(sendFeedbackAPI(feedBackData));

    if (res.type === "sendFeedbackAPI/fulfilled") {
      if (
        res.payload.success ||
        res.payload.status ||
        res.payload.data.status === 200
      ) {
        const closeButton = document.querySelector("#close-btn-feedback-model");
        if (closeButton) {
          closeButton.click();
        }
        toast.success("Your feedback has been successfully submitted");
        fetchAvailedServices();
        setShowFields("");
      } else {
        errorHandler(res.payload.errors);
      }
    } else if (res.type === "sendFeedbackAPI/rejected") {
      errorHandler(res.payload.errors);
    } else {
      toast.error("Sorry, something went wrong!");
    }
  };

  return (
    <>
      <SampleDashboardLayout>
        {loading ? (
          <div className="loading-center-on-page">
            <i
              style={{ fontSize: "52px" }}
              className="fa-solid fa-spinner fa-spin"
            ></i>
          </div>
        ) : availedServices?.length > 0 ? (
          <div className="container">
            <div className="row">
              {availedServices?.map((service, index) => {
                return (
                  <div
                    className="col-md-6"
                    onClick={() => handleDetailRequest(service?.id)}
                    data-bs-toggle="modal"
                    href="#employe-model"
                    role="button"
                    key={index}
                  >
                    <div className="rating-card-box rating-box-second">
                      <div className="rating-image">
                        {service?.user?.role?.name === "corporate" ? (
                          <img
                            src={`${base.imageUrl}${service?.employee?.images?.[0]?.path}`}
                            alt=""
                          />
                        ) : (
                          <img
                            src={`${base.imageUrl}${service?.user?.images?.[0]?.path}`}
                            alt=""
                          />
                        )}
                      </div>

                      <div className="review-text-main">
                        <div className="review-text-box">
                          <h1>
                            {service?.user?.role?.name === "corporate"
                              ? service?.employee?.name
                              : service?.user?.name}{" "}
                            <p>{service?.service?.name}</p>
                            {service?.status === "Accepted" ? (
                              ""
                            ) : (
                              <div className="rating-box">
                                <span>
                                  <i className="fa-solid fa-star"></i>{" "}
                                  {service?.feedback?.stars}.0
                                </span>
                              </div>
                            )}
                          </h1>
                        </div>

                        <div className="review-text-box mt-2">
                          <h1>
                            {/* <p className='none-border'>122 Reviews</p> */}
                            <p
                              style={{ borderLeft: "none" }}
                              className="ms-0 ps-0"
                            >
                              {service?.created_at &&
                                formatTime(service?.created_at)}
                            </p>
                            <p className="ms-0">
                              <span
                                className={`${service?.status === "Accepted"
                                  ? "in-progress"
                                  : ""
                                  } status-show`}
                              >
                                {service?.status === "Accepted"
                                  ? "In Progress"
                                  : "Completed"}
                              </span>
                            </p>
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="row">
              <div className="col-md-12">
                {/* Pagination Controls */}
                <div className="pagination">
                  {pagination.current_page > 1 && (
                    <button
                      onClick={() =>
                        handlePageChange(pagination.current_page - 1)
                      }
                    >
                      &laquo; Previous
                    </button>
                  )}

                  {[...Array(pagination.total_pages)].map((_, i) =>
                    pagination.total_pages >= 2 ? (
                      <button
                        key={i + 1}
                        className={
                          i + 1 === pagination.current_page ? "active" : ""
                        }
                        onClick={() => handlePageChange(i + 1)}
                      >
                        {i + 1}
                      </button>
                    ) : (
                      ""
                    )
                  )}

                  {pagination.current_page < pagination.total_pages && (
                    <button
                      onClick={() =>
                        handlePageChange(pagination.current_page + 1)
                      }
                    >
                      Next &raquo;
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <EmptyState
            title="No Services Yet"
            message="You haven't availed any services yet."
          />
        )}
      </SampleDashboardLayout>
      {/* MODEL THAT SHOW IN PROGRESS */}
      <div
        className="modal fade"
        id="employe-model"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabindex="-1"
      >
        <div className="modal-dialog modal-dialog-centered service-add-model model-width-control">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                id="close-btn-feedback-model"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>

            {detailLoading ? (
              <div className="loading-center-on-page">
                <i
                  style={{ fontSize: "52px" }}
                  className="fa-solid fa-spinner fa-spin"
                ></i>
              </div>
            ) : (
              <div className="modal-body">
                <div className="model-detail-box">
                  <div className="profile-picture">
                    {serviceDetail?.user?.role?.name === "corporate" ? (
                      <img
                        style={{ objectFit: "cover" }}
                        src={`${base.imageUrl}${serviceDetail?.employee?.images?.[0]?.path}`}
                        alt=""
                      />
                    ) : (
                      <img
                        style={{ objectFit: "cover" }}
                        src={`${base.imageUrl}${serviceDetail?.user?.images?.[0]?.path}`}
                        alt=""
                      />
                    )}
                  </div>

                  <h1>
                    {serviceDetail?.user?.role?.name === "corporate"
                      ? serviceDetail?.employee?.name
                      : serviceDetail?.user?.name}
                  </h1>

                  <div className="about-text-box">
                    <h2>About</h2>
                    <p className="common-text">
                      {serviceDetail?.user?.role?.name === "corporate"
                        ? serviceDetail?.employee?.about
                        : serviceDetail?.user?.about}
                    </p>
                    <span>
                      <i className="fas fa-map-marker-alt"></i>{" "}
                      {serviceDetail?.user?.address?.address}
                    </span>
                    <div>
                      <span className="category-box">
                        {serviceDetail?.service?.name}
                      </span>{" "}
                      <br />
                    </div>
                    <span>
                      {serviceDetail?.schedule?.day}:{" "}
                      {serviceDetail?.schedule?.start_time &&
                        formatTimeToAMPM(serviceDetail?.schedule?.start_time)}{" "}
                      To{" "}
                      {serviceDetail?.schedule?.end_time &&
                        formatTimeToAMPM(serviceDetail?.schedule?.end_time)}
                    </span>{" "}
                    <br />
                    {serviceDetail?.created_at && (
                      <span className="d-block">
                        <i className="fas fa-calendar-alt"></i>{" "}
                        Requested on {formatTime(serviceDetail?.created_at)}
                      </span>
                    )}
                    {serviceDetail?.status === "Accepted" ? (
                      <div className="model-buttons-box">
                        <Link to="/user/chat">
                          <span
                            data-bs-dismiss="modal"
                            className="category-box title-box-text accept-button-box"
                          >
                            Chat Now
                          </span>
                        </Link>

                        <span
                          className="category-box title-box-text me-2"
                          onClick={() => toggleDataReq("completed")}
                        >
                          Complete
                        </span>
                      </div>
                    ) : serviceDetail?.status === "Completed" ? (
                      <div>
                        <h2>Your Feedback</h2>

                        <div className="star-rating">
                          {[1, 2, 3, 4, 5].map((star) => (
                            <span
                              key={star}
                              className={`star ${star <= ratingStars
                                ? "yellow-star"
                                : "grey-star"
                                }`}
                              data-value={star}
                            >
                              <i className="fa-solid fa-star"></i>
                            </span>
                          ))}
                          <span className="star">
                            ({serviceDetail?.feedback?.stars}.0)
                          </span>
                        </div>

                        <p className="common-text">
                          {serviceDetail?.feedback?.message}
                        </p>

                        {serviceDetail?.feedback?.replies?.stars && (
                          <div>
                            <h2>Worker Feedback</h2>
                            <div className="star-rating">
                              {[1, 2, 3, 4, 5].map((star) => (
                                <span
                                  key={star}
                                  className={`star ${star <=
                                    serviceDetail?.feedback?.replies?.stars
                                    ? "yellow-star"
                                    : "grey-star"
                                    }`}
                                  data-value={star}
                                >
                                  <i className="fa-solid fa-star"></i>
                                </span>
                              ))}
                              <span className="star">
                                ({serviceDetail?.feedback?.replies?.stars}.0)
                              </span>
                            </div>

                            <p className="common-text">
                              {serviceDetail?.feedback?.replies?.message}
                            </p>
                          </div>
                        )}

                        <span className="category-box title-box-text">
                          Completed
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                    {showFields === "completed" && (
                      <div>
                        <h2 className="mb-0">Rate Us Now!</h2>

                        <form action="" onSubmit={handleRatingForm}>
                          <div
                            className="select-stars-rating mb-3"
                            style={{ display: "flex", gap: "5px" }}
                          >
                            {[...Array(5)].map((_, index) => (
                              <span
                                key={index}
                                style={{
                                  fontSize: "24px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleRating(index)}
                              >
                                <i
                                  style={{
                                    color: index < rating ? "gold" : "gray",
                                  }}
                                  className="fa-solid fa-star"
                                ></i>
                              </span>
                            ))}
                          </div>

                          <div className="custom-input-box about-company-textarea">
                            <textarea
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              placeholder="Leave a Review"
                              rows="3"
                              onChange={(e) => setRatingTextBox(e.target.value)}
                              value={ratingTextBox}
                              minLength={5}
                            ></textarea>
                          </div>

                          <div className="d-flex justify-content-end">
                            <button
                              className="category-box title-box-text"
                              style={{ cursor: "pointer" }}
                            >
                              {feedBackLoading ? (
                                <i
                                  style={{ fontSize: "22px" }}
                                  className="fa-solid fa-spinner fa-spin"
                                ></i>
                              ) : (
                                "Submit Review"
                              )}
                            </button>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SampleRating;
